export const RULE_STATE = {
  ACTIVE: "ACTIVE",
  DISABLED: "DISABLED",
} as const;

export type RuleStateType = (typeof RULE_STATE)[keyof typeof RULE_STATE];

export const RULE_SOURCE = {
  MANUAL: "MANUAL",
  SYSTEM: "SYSTEM",
} as const;

export type RuleSourceType = (typeof RULE_SOURCE)[keyof typeof RULE_SOURCE];

export const RULE_PRIORITY = {
  PRIORITY_1: "P1",
  PRIORITY_2: "P2",
  PRIORITY_3: "P3",
  PRIORITY_4: "P4",
} as const;

export type RulePriorityType =
  (typeof RULE_PRIORITY)[keyof typeof RULE_PRIORITY];

export const RULE_PRIORITY_OPTIONS = [
  { label: "Priority I", value: RULE_PRIORITY.PRIORITY_1 },
  { label: "Priority II", value: RULE_PRIORITY.PRIORITY_2 },
  { label: "Priority III", value: RULE_PRIORITY.PRIORITY_3 },
  { label: "Priority IV", value: RULE_PRIORITY.PRIORITY_4 },
] as const;

export const RULE_FIELD = {
  DESCRIPTION: "Description",
  AMOUNT: "Amount",
} as const;

export const REPEATABLE_RULE_FIELDS: string[] = [
  RULE_FIELD.DESCRIPTION,
  RULE_FIELD.AMOUNT,
];

export const RULE_OPERATOR = {
  IS_EXACTLY: "IS_EXACTLY",
  IS_EQUAL_TO: "IS_EQUAL_TO",
  IS_MORE_THAN: "IS_MORE_THAN",
  IS_MORE_THAN_EQUAL_TO: "IS_MORE_THAN_EQUAL_TO",
  IS_LESS_THAN: "IS_LESS_THAN",
  IS_LESS_THAN_EQUAL_TO: "IS_LESS_THAN_EQUAL_TO",
} as const;

export const EXCLUSIVE_RULE_OPERATORS: string[] = [
  RULE_OPERATOR.IS_EXACTLY,
  RULE_OPERATOR.IS_EQUAL_TO,
];

export const LOWER_BOUND_RULE_OPERATORS: string[] = [
  RULE_OPERATOR.IS_MORE_THAN,
  RULE_OPERATOR.IS_MORE_THAN_EQUAL_TO,
];

export const UPPER_BOUND_RULE_OPERATORS: string[] = [
  RULE_OPERATOR.IS_LESS_THAN,
  RULE_OPERATOR.IS_LESS_THAN_EQUAL_TO,
];

export const MAX_RULE_CONDITIONS = 10;

export const AMOUNT_RANGE_ERROR =
  "This amount range will match no transactions";
